export function canViewModule(resourceName) {
  try {
    const permissions = JSON.parse(localStorage.getItem("checkPermission") || "[]");
    const role = localStorage.getItem("role");
    const resource = permissions.find(p => p.resource === resourceName);
    if (['dashboard', 'setting', 'report'].includes(resourceName)) {
      return resource?.can_view === true;
    } else if (resourceName === 'reservation') {
      return resource?.can_view === true && role !== 'waiter' && role !== 'housekeeping';
    } else if (resourceName === 'rooms') {
      return resource?.can_view === true && role !== 'waiter';
    } else {
      return resource?.can_view === true;
    }
    
  } catch (e) {
    return false;
  }
} 